(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1526,289],{

/***/ 91925:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manfred-daily-companies",
      function () {
        return __webpack_require__(2310);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 66859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ StyledFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  padding: ",
        " ",
        " ",
        " ",
        ";\n  border-left: ",
        " solid ",
        ";\n  margin-left: -",
        ";\n  clip-path: polygon(\n    0 0,\n    100% 0,\n    calc(100% - ",
        ") 50%,\n    100% 100%,\n    0 100%\n  );\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n\n  &.without_icon {\n    padding: ",
        " ",
        " ",
        "\n      ",
        ";\n    font-size: ",
        ";\n  }\n\n  &.set2_04 {\n    background-color: ",
        ";\n  }\n\n  &.set1_05 {\n    background-color: ",
        ";\n  }\n\n  &.set1_03 {\n    background-color: ",
        ";\n  }\n\n  &.set1_01 {\n    background-color: ",
        ";\n  }\n\n  &.set1_04 {\n    background-color: ",
        ";\n  }\n\n  &.set1_02 {\n    background-color: ",
        ";\n  }\n\n  &.set1_07 {\n    background-color: ",
        ";\n  }\n\n  &.set1_09 {\n    background-color: ",
        ";\n  }\n\n  &.set3_04 {\n    background-color: ",
        ";\n  }\n\n  &.set3_10 {\n    background-color: ",
        ";\n  }\n\n  &.set3_05 {\n    background-color: ",
        ";\n  }\n\n  &.set3_01 {\n    background-color: ",
        ";\n  }\n\n  &.pastel1_01 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.pastel1_02 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.pastel1_03 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.pastel1_04 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.pastel1_05 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.AWARD {\n    background-color: ",
        ";\n  }\n\n  &.pastel1_06 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.dark2_03 {\n    background-color: ",
        ";\n  }\n\n  &.set3_06 {\n    background-color: ",
        ";\n  }\n\n  &.positive {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.negative {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledFlag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4debd7d-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_800"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set2_04"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_05"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_03"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_01"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_04"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_02"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_07"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_09"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_04"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_10"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_05"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_01"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_01"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_02"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_03"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_04"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_05"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_07"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_06"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("dark2_03"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_06"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_900"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("negative_500"));


/***/ }),

/***/ 67489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var _BadgeFlag_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66859);



var BadgeFlag = function(param) {
    var icon = param.icon, text = param.text, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BadgeFlag_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledFlag */ .O, {
        className: "".concat(color, " ").concat(icon ? "" : "without_icon"),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                icon: icon
            }),
            text
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BadgeFlag);


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 99655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.Cd; },
/* harmony export */   "XJ": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.XJ; },
/* harmony export */   "aC": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.aC; },
/* harmony export */   "by": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.by; },
/* harmony export */   "k8": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.k8; },
/* harmony export */   "nL": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.nL; }
/* harmony export */ });
/* harmony import */ var _Typography_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90637);



/***/ }),

/***/ 90637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ Heading6; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          width: ",
        ";\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f61a956f-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"));
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f61a956f-1"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"));
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f61a956f-2"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("mint_900"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"));
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-f61a956f-3"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"));
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-f61a956f-4"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-f61a956f-5"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"));


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 2310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ manfred_daily_companies; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/dailyCompanies/sections/hero/DailyHero.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: center bottom;\n  background-size: cover;\n  padding: ",
        " ",
        " 0;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    background-image: ",
        ";\n    background-position: left 15% bottom;\n    padding: ",
        " ",
        " 0;\n    background-position: center bottom;\n    margin-bottom: ",
        ";\n    background-size: cover;\n  }\n\n  @media (min-width: ",
        ") {\n    background-image: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  line-height: 1.5;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n    gap: ",
        ";\n  }\n\n  img {\n    max-width: 528px;\n    margin-bottom: -",
        ";\n\n    @media (min-width: ",
        ") {\n      width: 50%;\n      margin-bottom: 0;\n      margin-top: -",
        ";\n    }\n  }\n\n  > div {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-bottom: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.2;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.25em;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    letter-spacing: 0.35em;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17511d0-0"
})(_templateObject(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/manfredDaily/bg-hero-sm.svg"), "')");
}, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/manfredDaily/bg-hero.svg"), "')");
}, (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("lg"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/manfredDaily/bg-hero-lg.svg"), "')");
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17511d0-1"
})(_templateObject1(), (0,theme/* container */.nC)("xl"));
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17511d0-2"
})(_templateObject2(), (0,theme/* color */.$_)("text_white"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* container */.nC)("md"));
var StyledPreTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-17511d0-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/dailyCompanies/sections/hero/DailyHero.tsx





var DailyHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("manfred-daily").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHero, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPreTitle, {
                                children: t("manfred-daily.hero.pre-title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                                as: "h1",
                                children: t("manfred-daily.hero.title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/manfredDaily/hero.svg"),
                        alt: ""
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_DailyHero = (DailyHero);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/BadgeFlag.tsx
var BadgeFlag = __webpack_require__(67489);
// EXTERNAL MODULE: ./components/shared/BadgeFlag.styled.ts
var BadgeFlag_styled = __webpack_require__(66859);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
;// CONCATENATED MODULE: ./components/marketingSite/dailyCompanies/sections/pricing/DailyPricing.styled.ts

function DailyPricing_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    DailyPricing_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DailyPricing_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin: 0 auto;\n\n  ",
        " {\n    text-align: center;\n    margin-bottom: ",
        ";\n    margin-top: 0;\n  }\n"
    ]);
    DailyPricing_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DailyPricing_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: stretch;\n    gap: ",
        ";\n  }\n"
    ]);
    DailyPricing_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DailyPricing_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 25rem;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        " ",
        " 0;\n  box-shadow: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        " ",
        " 0;\n  }\n"
    ]);
    DailyPricing_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.2;\n  font-weight: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.14;\n  }\n\n  &::before {\n    content: '';\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: flex-start;\n  line-height: 1.25;\n\n  svg {\n    color: ",
        ";\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  margin: 0 -",
        ";\n  border-radius: 0 0 ",
        " ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        " ",
        ";\n    margin: 0 -",
        ";\n  }\n\n  ",
        " {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var DailyPricing_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c21aec40-0"
})(DailyPricing_styled_templateObject(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"));
var DailyPricing_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c21aec40-1"
})(DailyPricing_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), Typography_styled/* Heading2 */.XJ, (0,theme/* spacing */.W0)("xl2"));
var StyledList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c21aec40-2"
})(DailyPricing_styled_templateObject2(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"));
var StyledItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c21aec40-3"
})(DailyPricing_styled_templateObject3(), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("md"), (0,theme/* shadow */.AF)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"));
var StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-c21aec40-4"
})(_templateObject4(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("cyan_700"));
var StyledAds = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c21aec40-5"
})(_templateObject5(), (0,theme/* color */.$_)("midnight_150"), (0,theme/* radius */.q0)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_subtle"));
var StyledFeatures = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c21aec40-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("md"));
var StyledFeatureItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-c21aec40-7"
})(_templateObject7(), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("positive_500"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c21aec40-8"
})(_templateObject8(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("lg"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), BadgeFlag_styled/* StyledFlag */.O, (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs"));
var StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c21aec40-9"
})(_templateObject9(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* fontWeight */.Ue)("semiBold"));

;// CONCATENATED MODULE: ./components/marketingSite/dailyCompanies/sections/pricing/DailyPricing.tsx







var DailyPricing = function() {
    var t = (0,useI18n/* useI18n */.Q)("manfred-daily").t;
    var pricing = [
        {
            title: t("manfred-daily.pricing.tier1.title"),
            ads: t("manfred-daily.pricing.tier1.ads"),
            features: [
                t("manfred-daily.pricing.tier1.feature1"),
                t("manfred-daily.pricing.tier1.feature2")
            ],
            price: t("manfred-daily.pricing.tier1.price")
        },
        {
            title: t("manfred-daily.pricing.tier2.title"),
            ads: t("manfred-daily.pricing.tier2.ads"),
            features: [
                t("manfred-daily.pricing.tier2.feature1"),
                t("manfred-daily.pricing.tier2.feature2"),
                t("manfred-daily.pricing.tier2.feature3")
            ],
            price: t("manfred-daily.pricing.tier2.price"),
            discount: t("manfred-daily.pricing.tier2.discount")
        },
        {
            title: t("manfred-daily.pricing.tier3.title"),
            ads: t("manfred-daily.pricing.tier3.ads"),
            features: [
                t("manfred-daily.pricing.tier3.feature1"),
                t("manfred-daily.pricing.tier3.feature2"),
                t("manfred-daily.pricing.tier3.feature3"),
                t("manfred-daily.pricing.tier3.feature4")
            ],
            price: t("manfred-daily.pricing.tier3.price"),
            discount: t("manfred-daily.pricing.tier3.discount")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DailyPricing_styled_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DailyPricing_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                    editorial: true,
                    children: t("manfred-daily.pricing.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
                    children: pricing.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAds, {
                                    children: item.ads
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatures, {
                                    children: item.features.map(function(feature, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeatureItem, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: feature
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrice, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledValue, {
                                            children: item.price
                                        }),
                                        item.discount && /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeFlag/* default */.Z, {
                                            color: "positive",
                                            text: item.discount
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var pricing_DailyPricing = (DailyPricing);

// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./components/marketingSite/dailyCompanies/sections/features/DailyFeatures.styled.ts

function DailyFeatures_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin: ",
        " auto;\n\n  ",
        " {\n    text-align: center;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    DailyFeatures_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DailyFeatures_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n\n    &.reverse {\n      flex-direction: row-reverse;\n    }\n  }\n\n  > div {\n    line-height: 1.5;\n\n    @media (min-width: ",
        ") {\n      max-width: 50%;\n    }\n\n    :last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  ",
        " {\n    margin-top: 0;\n    margin-bottom: ",
        ";\n  }\n\n  ol {\n    padding-left: ",
        ";\n\n    li {\n      list-style: auto;\n    }\n  }\n\n  img {\n    width: 100%;\n    max-width: 33rem;\n    margin: auto;\n\n    @media (min-width: ",
        ") {\n      width: 50%;\n    }\n  }\n"
    ]);
    DailyFeatures_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DailyFeatures_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: ",
        ";\n\n  p {\n    margin: 0;\n    color: ",
        ";\n    line-height: 1.5;\n  }\n"
    ]);
    DailyFeatures_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DailyFeatures_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    DailyFeatures_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DailyFeatures_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    DailyFeatures_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var DailyFeatures_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-992dbe6c-0"
})(DailyFeatures_styled_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl5"), Typography_styled/* Heading2 */.XJ, (0,theme/* spacing */.W0)("xl2"));
var StyledFeature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-992dbe6c-1"
})(DailyFeatures_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"), Typography_styled/* Heading3 */.aC, (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"));
var StyledHighlight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-992dbe6c-2"
})(DailyFeatures_styled_templateObject2(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_subtle"));
var StyledHighlightIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-992dbe6c-3"
})(DailyFeatures_styled_templateObject3(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("info_500"), (0,theme/* color */.$_)("white"), (0,theme/* fontSize */.JB)("xl"));
var StyledHighlightTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading3 */.aC).withConfig({
    componentId: "sc-992dbe6c-4"
})(DailyFeatures_styled_templateObject4(), (0,theme/* color */.$_)("info_500"));

;// CONCATENATED MODULE: ./components/marketingSite/dailyCompanies/sections/features/DailyFeatures.tsx











var DailyFeatures = function(param) {
    var contactRef = param.contactRef;
    var t = (0,useI18n/* useI18n */.Q)("manfred-daily").t;
    var handleButtonClick = function() {
        service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("manfred-daily-contacta-typeform");
        if (contactRef.current) {
            contactRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DailyFeatures_styled_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("manfred-daily.features.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeature, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                editorial: true,
                                alignLeft: true,
                                children: t("manfred-daily.features.telegram-title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "manfred-daily",
                                i18nKey: "manfred-daily.features.telegram-desc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/manfredDaily/telegram.png"),
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHighlight, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHighlightIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faPaperPlane */.XCy
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHighlightTitle, {
                        children: t("manfred-daily.features.highlight-title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "manfred-daily",
                        i18nKey: "manfred-daily.features.highlight-desc"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                        schema: "brand1",
                        variant: "hard",
                        size: "xs",
                        label: t("manfred-daily.features.highlight-cta"),
                        startIcon: free_solid_svg_icons/* faCheckCircle */.f8k,
                        href: "https://t.me/getmanfred",
                        target: "_blank",
                        onClick: handleButtonClick
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeature, {
                className: "reverse",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                editorial: true,
                                alignLeft: true,
                                children: t("manfred-daily.features.publish-title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "manfred-daily",
                                i18nKey: "manfred-daily.features.publish-desc"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                                schema: "brand1",
                                variant: "hard",
                                size: "xs",
                                label: t("manfred-daily.features.publish-cta"),
                                endIcon: pro_light_svg_icons/* faArrowRight */.eFW,
                                onClick: handleButtonClick
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/manfredDaily/ads.png"),
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeature, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                editorial: true,
                                alignLeft: true,
                                children: t("manfred-daily.features.report-title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "manfred-daily",
                                i18nKey: "manfred-daily.features.report-desc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/manfredDaily/report.png"),
                        alt: ""
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var features_DailyFeatures = (DailyFeatures);

;// CONCATENATED MODULE: ./components/marketingSite/dailyCompanies/sections/contact/DailyContact.styled.tsx

function DailyContact_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n  position: relative;\n  overflow: hidden;\n"
    ]);
    DailyContact_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DailyContact_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  z-index: 1;\n  position: relative;\n  max-width: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.4;\n"
    ]);
    DailyContact_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DailyContact_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: ",
        ";\n  margin-left: auto;\n  margin-right: auto;\n  font-size: ",
        ";\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n\n  ",
        "::before {\n    background-color: ",
        ";\n  }\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    DailyContact_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DailyContact_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 8rem;\n  height: 8rem;\n  border-radius: ",
        ";\n  margin: 0 auto ",
        ";\n  padding: ",
        ";\n  display: flex;\n  gap: ",
        ";\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    DailyContact_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var DailyContact_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-efef94f3-0"
})(DailyContact_styled_templateObject(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"));
var DailyContact_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-efef94f3-1"
})(DailyContact_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-efef94f3-2"
})(DailyContact_styled_templateObject2(), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), Typography_styled/* Heading2 */.XJ, (0,theme/* color */.$_)("info_500"), (0,theme/* color */.$_)("text_subtle"));
var StyledIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-efef94f3-3"
})(DailyContact_styled_templateObject3(), (0,theme/* color */.$_)("info_500"), (0,theme/* radius */.q0)("full"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"));

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/marketingSite/dailyCompanies/sections/contact/DailyContact.tsx








var ManfredDailyForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3955), __webpack_require__.e(1534), __webpack_require__.e(2987), __webpack_require__.e(6248), __webpack_require__.e(5100)]).then(__webpack_require__.bind(__webpack_require__, 40001));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40001)
            ];
        }
    },
    ssr: false
});
var DailyContact = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,useI18n/* useI18n */.Q)("manfred-daily").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DailyContact_styled_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DailyContact_styled_StyledContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIcon, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/isotype-manfred-white.svg"),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("manfred-daily.contact.icon")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading2 */.XJ, {
                            editorial: true,
                            children: t("manfred-daily.contact.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "manfred-daily",
                                i18nKey: "manfred-daily.contact.desc"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManfredDailyForm, {})
            })
        ]
    });
});
DailyContact.displayName = "DailyContact";
/* harmony default export */ var contact_DailyContact = (DailyContact);

;// CONCATENATED MODULE: ./components/marketingSite/dailyCompanies/DailyCompaniesComponent.tsx







var DailyCompaniesComponent = function() {
    var contactRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        pageVariant: "light",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_DailyHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(features_DailyFeatures, {
                contactRef: contactRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_DailyPricing, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_DailyContact, {
                ref: contactRef
            })
        ]
    });
};
/* harmony default export */ var dailyCompanies_DailyCompaniesComponent = (DailyCompaniesComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./pages/manfred-daily-companies.tsx







var DailyCompaniesPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("manfred-daily").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("manfred-daily.page_title"),
                desc: t("manfred-daily.page_description"),
                url: app_urls/* APP_URLS.manfredDailyCompanies */.uu.manfredDailyCompanies,
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_manfreddaily_companies.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dailyCompanies_DailyCompaniesComponent, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var manfred_daily_companies = (DailyCompaniesPage);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,9774,2888,179], function() { return __webpack_exec__(91925); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);